import cx from 'classnames';

import './Spinner.scss';

/**
 * @deprecated use Spinner from '@frontend/components' instead.
 */
const Spinner = ({ large: isLarge, white: isWhite, className, ...props }) => {
  const classes = cx('Spinner', className, {
    isLarge,
    isWhite,
  });

  return (
    <div className={classes} {...props}>
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
      <div className="Spinner__bar" />
    </div>
  );
};

export default Spinner;
